export const Role = {
  /** @type {'admin'} */
  ADMIN: "admin",
  /** @type {'adminWithoutReport'} */
  ADMIN_WITHOUT_REPORT: "adminWithoutReport",
  /** @type {'teamLeader'} */
  TEAM_LEADER: "teamLeader",
  /** @type {'teamMember'} */
  TEAM_MEMBER: "teamMember",
}

export const ROLES_TO_SHOW = {
  /** @type {'Administrador'} */
  admin: "Administrador",
  /** @type {'Integrante del equipo'} */
  teamMember: "Integrante del equipo",
  /** @type {'Líder de equipo'} */
  teamLeader: "Líder de equipo",
  /** @type {'Administrador'} */
  adminWithoutReport: "Administrador",
}

export const TEAM_AREAS_NAMES = {
  1: "Desarrollo",
  2: "Diseño",
}

export const BASE_ROUTE_PER_ROLE = {
  admin: "/dashboard",
  teamMember: "/registro-de-tiempos",
  teamLeader: "/registro-de-tiempos",
  adminWithoutReport: "/registro-de-tiempos",
}
